import { useQuery } from '@tanstack/react-query';
import { GlobalReactQueryOptions } from '../../config';
import { AxiosError } from 'axios';
import { log } from '../../shared/utils/log';
import { globalErrorResponse } from '../../shared/notification/actions';
import { FetchAggregations } from '../listContent/fetchAggregations';
import { QueryKeyBuilder } from '../../shared/filter/useAggregationsQuery';
import { LENDING_MODEL_OCOU } from '../../store/constants';

export const useCheckUsageConditions = (fetchFunction: FetchAggregations, queryKeyBuilder: QueryKeyBuilder) => {
    const { data = false, ...rest } = useQuery(
        ['checkUsageConditions', ...queryKeyBuilder({ filters: {}, expandedFilterGroups: ['lendingModel'] })],
        () => fetchFunction({ filters: { lendingModel: { include: [], exclude: [] } } }),
        {
            ...GlobalReactQueryOptions,
            select: data => {
                const buckets = data.aggregations?.lendingModel?.buckets ?? [];

                return buckets.length === 1 && buckets[0].key === LENDING_MODEL_OCOU;
            },
            onError: (error: AxiosError) => {
                log.error(error);
                if (error.response?.status !== 404) {
                    globalErrorResponse(error);
                }
            }
        }
    );

    return { data, ...rest };
};
